import React from 'react'
import { Button, Input } from 'antd'
import { Icon } from '@ant-design/compatible'
import { IUdModalContentProps, UdModal } from '@ud/admin-framework'
import IconList from './IconList'
import './IconSelector.less'

class IconSelector extends React.Component<IIconSelectorProps, IIconSelectorState> {

  constructor(props: any) {
    super(props)
    this.state = {}
  }

  render() {
    const { value } = this.props
    return (
      <div className="icont-template">
        <div className="icon-box">
          <Input value={value} onChange={(e) => {
            this.props.onChange(e.target.value)
          }} />
          <Icon type={value} />
        </div>
        <div className="btn-box">
          <Button type="link" onClick={this.checkIcon}>选择Icon图标</Button>
        </div>
      </div>
    )
  }

  protected checkIcon = () => {
    UdModal.open({
      title: '选择图标',
      width: 1000,
      bodyStyle: { height: '600px' },
      content: <IconList value={this.props.value} />,
      onOk: (value) => {
        this.props.onChange(value)
      }
    })
  }

}

interface IIconSelectorProps extends IUdModalContentProps {
  value?: string,
  onChange?: any
}

interface IIconSelectorState {

}

export default IconSelector
